import {
    createContext,
    useContext,
    useReducer,
    useMemo,
} from 'react';

export const SiteInfoContext = createContext(null);

export const useSiteInfo = () => {
    return useContext(SiteInfoContext);
};

const siteInfoReducer = (state, action) => {
    switch (action.type) {
    case 'SET_IS_SHOW_JOIN_NOW_BUTTON':
        return { ...state, isShowJoinNowButton: action.value };
    default:
        return state;
    }
};

export const SiteInfoProvider = ({ children, siteInfo }) => {
    const initialState = {
        isShowJoinNowButton: false,
        ...(siteInfo || {}),
    };
    const [state, dispatch] = useReducer(siteInfoReducer, initialState);

    const setIsShowJoinNowButton = (isShowJoinNowButton) => {
        dispatch({ type: 'SET_IS_SHOW_JOIN_NOW_BUTTON', value: isShowJoinNowButton });
    };

    const contextValue = useMemo(
        () => ({
            ...state,
            dispatch,
            setIsShowJoinNowButton,
        }),
        [state],
    );

    return (
        <SiteInfoContext.Provider value={contextValue}>
            {children}
        </SiteInfoContext.Provider>
    );
};
